var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoGithub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7_1779)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 0.300049C5.4 0.300049 0 5.70005 0 12.3C0 17.625 3.45 22.1251 8.175 23.7001C8.775 23.7751 9 23.475 9 23.1C9 22.8001 9 22.0501 9 21.0751C5.625 21.8251 4.95 19.5001 4.95 19.5001C4.425 18.1501 3.6 17.7751 3.6 17.7751C2.475 17.0251 3.675 17.0251 3.675 17.0251C4.875 17.1001 5.55 18.225 5.55 18.225C6.6 20.0251 8.325 19.5001 9.075 19.2001C9.15 18.4501 9.525 17.9251 9.825 17.625C7.125 17.3251 4.35 16.2751 4.35 11.7001C4.35 10.425 4.8 9.30005 5.55 8.47505C5.4 8.17505 5.025 6.97505 5.7 5.32505C5.7 5.32505 6.675 5.02505 9 6.52505C9.975 6.22505 10.95 6.15005 12 6.15005C13.05 6.15005 14.025 6.30005 15 6.52505C17.325 4.95005 18.3 5.25005 18.3 5.25005C18.975 6.90005 18.525 8.10005 18.45 8.40005C19.2 9.22505 19.65 10.2751 19.65 11.625C19.65 16.2001 16.875 17.25 14.175 17.5501C14.625 17.9251 15 18.6751 15 19.8001C15 21.375 15 22.725 15 23.1C15 23.4001 15.225 23.7751 15.825 23.7001C20.55 22.1251 24 17.625 24 12.3C24 5.70005 18.6 0.300049 12 0.300049Z",
    fill: "#C9FFBF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7_1779"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoGithub);
export default __webpack_public_path__ + "static/media/logo-github.766a0830ab4a2c1da2023e48adaebb0b.svg";
export { ForwardRef as ReactComponent };